export default __webpack_public_path__ + "static/barber_men-b2d07d448f638744dd9b36a3585d1e9f.jpg";